import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../../../Common/DataTable';
import { RootState } from '../../../../redux/rootState';
import { setLoader } from '../../../../redux/loaderSlice';
import ComponentDeleteModal from '../../../../Common/DeleteModal/ComponentDeleteModal';
import ComponentSupportListDialog from './ComponentSupportListDialog';
import { deleteSupportListStart, getSupportListStart } from '../redux/sliceSupportList';
import { SupportList } from '../utils/types';
import { defaultPageSize } from '../../../../utils/Constant';

function ComponentSupportListTable() {
  const [open, setOpen] = useState(false);
  const [rowId, setRowId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedSupportListId, setSelectedSupportListId] = useState<string>('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const dispatch = useDispatch();

  const { isLoading, SupportListData } = useSelector((state: RootState) => state.ListSupportReducer);
  const { showDeleteIcon } = useSelector((state: RootState) => state.masterDataReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
      sortColumn,
      sortDirection,
    };
    dispatch(getSupportListStart(params));
  };
  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortColumn, sortDirection]);

  const handleAction = (id: string) => {
    setOpen(true);
    setRowId(id);
  };

  const handleButtonClick = () => {
    setRowId('');
    setOpen(!open);
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const TableColumns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'Description', label: 'Description' },
    ],
    [],
  );

  const tableData: SupportList[] = useMemo(() => SupportListData?.Data?.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      action: showDeleteIcon ? 'edit&delete' : 'edit',
      Description: item?.Description,
      id: String(item?.Id),
    };
    return transformedDataItem;
  }), [SupportListData]);

  const handleDelete = (id: string) => {
    setShowDeleteModal(true);
    setSelectedSupportListId(id);
  };

  const handelDeleteModal = () => {
    const paramData = {
      Id: selectedSupportListId,
      page,
      rowsPerPage,
      searchQuery,
      sortColumn,
      sortDirection,
    };
    dispatch(deleteSupportListStart(paramData));
    setShowDeleteModal(false);
  };

  return (
    <>
      <DataTable<SupportList>
        handleButtonClick={handleButtonClick}
        data={tableData}
        columns={TableColumns}
        totalRecords={SupportListData?.TotalRecords}
        buttonText="Add"
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
        sortCol={sortColumn}
        setSortCol={(e) => { setSortColumn(e); setPage(1); }}
        sortDir={sortDirection}
        setSortDir={(e) => { setSortDirection(e); setPage(1); }}
        handleData={handleData}
        handleEdit={handleAction}
        handleDelete={handleDelete}
        handleDataFromComponent
      />
      <ComponentSupportListDialog show={open} setOpenFrom={handleButtonClick} rowId={rowId} handleData={handleData} />
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setShowDeleteModal(false)}
        handleDelete={handelDeleteModal}
      />
    </>
  );
}

export default ComponentSupportListTable;
